import React, { FC, useMemo } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { eventsConfig, eventsOptions } from 'constants/eventOptions';
import { SelectFields } from 'components/forms';

const SelectWithEventsFieldsWrapper: FC<FieldRenderProps<[]>> = (props) => {
  const { children, render, input, ...otherProps } = props;
  const options = useMemo(() => eventsOptions.filter((option) => eventsConfig[option.value]), []);
  return <SelectFields options={options} config={eventsConfig} {...input} {...otherProps} />;
};

export default SelectWithEventsFieldsWrapper;
